import { faEdit, faEye, faTrashAlt } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { Button, Col, Container, Form, Nav, Row, Table } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import AsyncSelect from 'react-select/async';
import ActivityLog from '../ActivityLog';
import * as Common from '../Common';
import Dialog from '../Dialog';
import LoginHeader from "../Login_header";
import Menu from '../Menu';
import * as Picklist from "../Picklist";

function Master_Credit_Schedule() {
    const navigate = useNavigate();
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState("");

    const sid = sessionStorage.getItem('sessionId');
    const [onceRun, setOnceRun] = useState(false);
    const [scrMode, setScrMode] = useState("Q");  // "Q A E V"
    const [activeSection, setActiveSection] = useState("info");

    const [creditScheduleData, setCreditScheduleData] = useState([]);
    const [showAddEditForm, setAddEditFormShow] = useState(false);
    const [showAddNewBtn, setShowAddNewBtn] = useState(true);

    // info tab - all field state management
    const [srNo, setSrNo] = useState(0);
    const [grpCode, setGrpCode] = useState('');
    const [ledgerValue, setLedgerValue] = useState(null);
    const [accCode, setAccCode] = useState('0');
    const [ledgerName, setLedgerName] = useState('');
    const [mrcsTime, setMrcsTime] = useState('');
    const [emailRateCardActive, setEmailRateCardActive] = useState('0');
    const [emailTo, setEmailTo] = useState('');
    const [emailCc, setEmailCc] = useState('');
    const [emailBcc, setEmailBcc] = useState('');
    const [addCurrencyBuyRate, setAddCurrencyBuyRate] = useState('0');
    const [addCurrencySellRate, setAddCurrencySellRate] = useState('0');
    const [addCardBuyRate, setAddCardBuyRate] = useState('0');
    const [addCardSellRate, setAddCardSellRate] = useState('0');
    const [addRemittanceBuyRate, setAddRemittanceBuyRate] = useState('0');
    const [addRemittanceSellRate, setAddRemittanceSellRate] = useState('0');

    // configuration tab - all field state management
    const [currency, setCurrency] = useState('');
    const [currencyIsd, setCurrencyIsd] = useState('');
    const [isdValue, setIsdValue] = useState(null);
    const [originalIsd, setOriginalIsd] = useState('');
    const [active, setActive] = useState('1');
    const [priority, setPriority] = useState('');

    const [currencyBuyFlat, setCurrencyBuyFlat] = useState('');
    const [currencyBuyFlatType, setCurrencyBuyFlatType] = useState('F');
    const [currencyBuyMargin, setCurrencyBuyMargin] = useState('');
    const [currencySellFlat, setCurrencySellFlat] = useState('');
    const [currencySellFlatType, setCurrencySellFlatType] = useState('F');
    const [currencySellMargin, setCurrencySellMargin] = useState('');

    const [cardBuyFlat, setCardBuyFlat] = useState('');
    const [cardBuyFlatType, setCardBuyFlatType] = useState('F');
    const [cardBuyMargin, setCardBuyMargin] = useState('');
    const [cardSellFlat, setCardSellFlat] = useState('');
    const [cardSellFlatType, setCardSellFlatType] = useState('F');
    const [cardSellMargin, setCardSellMargin] = useState('');

    const [remittanceBuyFlat, setRemittanceBuyFlat] = useState('');
    const [remittanceBuyFlatType, setRemittanceBuyFlatType] = useState('F');
    const [remittanceBuyMargin, setRemittanceBuyMargin] = useState('');
    const [remittanceSellFlat, setRemittanceSellFlat] = useState('');
    const [remittanceSellFlatType, setRemittanceSellFlatType] = useState('F');
    const [remittanceSellMargin, setRemittanceSellMargin] = useState('');

    const [savedConfigList, setSavedConfigList] = useState([]);
    const [newConfigList, setNewConfigList] = useState([]);
    const [userRight, setUserRight] = useState([]);
    const [logObject, setLogObject] = useState({ trantype: "", trannumber: "", trancategory: "" });
    const [showActivityLog, setShowActivityLog] = useState(false);
    const [editingConfigIndex, setEditingConfigIndex] = useState(null);
    const [isDuplicate, setIsDuplicate] = useState(false);

    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.callApi(Common.apiRight, [sid, 'all', 'MCREDITSCHEDULE'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    setUserRight(resp);
                } else {
                    navigate('/');
                }
            });
            getList();
            setOnceRun(true);
        }
    }, [onceRun, sid, navigate]);

    function getList() {
        Common.callApi(Common.apiCredit, [sid, 'listjson'], function (result) {
            let resp = JSON.parse(result);
            if (Array.isArray(resp)) {
                setCreditScheduleData(resp);
            }
        });
    }

    function resetConfigOnlyFields() {
        setCurrency('');
        setCurrencyIsd('');
        setIsdValue(null);
        setOriginalIsd('');
        setActive('1');
        setPriority('');

        setCurrencyBuyFlat('');
        setCurrencyBuyFlatType('F');
        setCurrencyBuyMargin('');
        setCurrencySellFlat('');
        setCurrencySellFlatType('F');
        setCurrencySellMargin('');

        setCardBuyFlat('');
        setCardBuyFlatType('F');
        setCardBuyMargin('');
        setCardSellFlat('');
        setCardSellFlatType('F');
        setCardSellMargin('');

        setRemittanceBuyFlat('');
        setRemittanceBuyFlatType('F');
        setRemittanceBuyMargin('');
        setRemittanceSellFlat('');
        setRemittanceSellFlatType('F');
        setRemittanceSellMargin('');
    }

    function resetConfigFields() {
        setGrpCode('');
        setAccCode('0');
        setLedgerValue(null);
        setLedgerName('');
        setEmailRateCardActive('0');
        setEmailTo('');
        setEmailCc('');
        setEmailBcc('');
        setAddCurrencyBuyRate('0');
        setAddCurrencySellRate('0');
        setAddCardBuyRate('0');
        setAddCardSellRate('0');
        setAddRemittanceBuyRate('0');
        setAddRemittanceSellRate('0');
        resetConfigOnlyFields();
    }

    function cancelData() {
        setAddEditFormShow(false);
        setShowAddNewBtn(true);
        setScrMode("Q");
        setActiveSection("info");
        setEditingConfigIndex(null);
        setIsDuplicate(false);
    }

    function btnBackClick() {
        if (activeSection === "configuration") {
            setActiveSection("info");
            setEditingConfigIndex(null);
        } else {
            cancelData();
        }
    }

    function addNew() {
        setSrNo(0);
        setMrcsTime('');
        setSavedConfigList([]);
        setNewConfigList([]);
        resetConfigFields();
        setIsDuplicate(false);
        setActiveSection("info");
        setAddEditFormShow(true);
        setShowAddNewBtn(false);
        setScrMode("A");
    }

    function fillViewForm(srno, groupCode, accountCode) {
        const obj = {
            srno: srno,
            grpCode: groupCode,
            accCode: accountCode
        }
        Common.callApi(Common.apiCredit, [sid, 'detail', JSON.stringify(obj)], function (result) {
            let resp = JSON.parse(result);
            let data = resp.Info;
            if (!data || Object.keys(data).length === 0) return;

            setSrNo(data.mrcs_srno);
            setGrpCode(data.mrcs_group_code);
            setAccCode(data.mvli_srno);
            setMrcsTime(data.mrcs_time || '');
            setEmailRateCardActive(data.mvli_email_rate_card_active || '0');
            setEmailTo(data.mvli_rate_card_email_to || '');
            setEmailCc(data.mvli_rate_card_email_cc || '');
            setEmailBcc(data.mvli_rate_card_email_bcc || '');
            setAddCurrencyBuyRate(data.mvli_rate_card_add_currency_buy_rate || '0');
            setAddCurrencySellRate(data.mvli_rate_card_add_currency_sell_rate || '0');
            setAddCardBuyRate(data.mvli_rate_card_add_card_buy_rate || '0');
            setAddCardSellRate(data.mvli_rate_card_add_card_sell_rate || '0');
            setAddRemittanceBuyRate(data.mvli_rate_card_add_remittance_buy_rate || '0');
            setAddRemittanceSellRate(data.mvli_rate_card_add_remittance_sell_rate || '0');
            const accValue = `0^${data.mrcs_group_code}^${data.mrcs_account_code}^${data.mvli_srno}^`;
            setLedgerValue({
                id: accValue,
                label: `${data.mvli_group} ${data.mvli_srno} ${data.mvli_ledger_name}`
            });
            setLedgerName(data.mvli_ledger_name);
            setSavedConfigList(Array.isArray(resp.Configuration) ? resp.Configuration : []);
            setNewConfigList([]);
            setActiveSection("info");
            setAddEditFormShow(true);
            setShowAddNewBtn(false);
            setScrMode("V");
        });
    }

    function btnEditClick() {
        setScrMode("E");
    }

    function addConfigEntry() {
        if (!ledgerValue || !currency || !active) {
            setMsgText(Common.getMessage("MSG0006"));
            setMsgBox(true);
            return;
        }
        const emptyToNull = (val) => (val === '' || val === undefined ? null : val);
        const entryCurrency = emptyToNull(currencyIsd);
        // check is any entry already save in list coming from db having group account and currency (same)
        const isDuplicateInSaved = savedConfigList.some(e =>
            e.mrcc_group_code === grpCode && e.mrcc_account_code === accCode && e.mrcc_isd === entryCurrency
        );
        // check is any entry already added to newconfiglist with same group account and currency (same)
        const isDuplicateInList = newConfigList.some(e =>
            e.groupCode === grpCode && e.accountCode === accCode && e.currency === entryCurrency
        );
        if (isDuplicateInList || isDuplicateInSaved) {
            setMsgText('Configuration entry already exists with this group code, account code and currency.');
            setMsgBox(true);
            return;
        }
        const entry = {
            ledgerName: ledgerName,
            groupCode: grpCode,
            accountCode: accCode,
            scheduleSrNo: srNo,
            currency: emptyToNull(currencyIsd),
            currencyName: emptyToNull(currency),
            active: emptyToNull(active),
            priority: emptyToNull(priority),
            currencyBuyFlat: emptyToNull(currencyBuyFlat),
            currencyBuyFlatType: currencyBuyFlatType,
            currencyBuyMargin: emptyToNull(currencyBuyMargin),
            currencySellFlat: emptyToNull(currencySellFlat),
            currencySellFlatType: currencySellFlatType,
            currencySellMargin: emptyToNull(currencySellMargin),
            cardBuyFlat: emptyToNull(cardBuyFlat),
            cardBuyFlatType: cardBuyFlatType,
            cardBuyMargin: emptyToNull(cardBuyMargin),
            cardSellFlat: emptyToNull(cardSellFlat),
            cardSellFlatType: cardSellFlatType,
            cardSellMargin: emptyToNull(cardSellMargin),
            remittanceBuyFlat: emptyToNull(remittanceBuyFlat),
            remittanceBuyFlatType: remittanceBuyFlatType,
            remittanceBuyMargin: emptyToNull(remittanceBuyMargin),
            remittanceSellFlat: emptyToNull(remittanceSellFlat),
            remittanceSellFlatType: remittanceSellFlatType,
            remittanceSellMargin: emptyToNull(remittanceSellMargin)
        };
        setNewConfigList(prev => [...prev, { ...entry }]);
        resetConfigOnlyFields();
    }

    function removeConfigEntry(index) {
        setNewConfigList(prev => prev.filter((_, i) => i !== index));
    }

    function saveData() {
        if (editingConfigIndex !== null) {
            saveConfigUpdate(editingConfigIndex);
            return;
        }
        if (!grpCode || !ledgerValue || !mrcsTime) {
            setMsgText(Common.getMessage("MSG0006"));
            setMsgBox(true);
            return;
        }
        if (!emailTo || !emailCc || !emailBcc) {
            setMsgText('Email To, CC and BCC are mandatory fields.');
            setMsgBox(true);
            return;
        }
        if (isDuplicate) {
            setMsgText('Existing entry already Exist with this group and Account Code');
            setMsgBox(true);
            return;
        }

        const infoObj = {
            srno: srNo,
            groupCode: grpCode,
            accountCode: accCode,
            ledgerName: ledgerName,
            time: mrcsTime,
            emailTo: emailTo,
            emailCc: emailCc,
            emailBcc: emailBcc,
            emailRateCardActive: emailRateCardActive,
            addCurrencyBuyRate: addCurrencyBuyRate,
            addCurrencySellRate: addCurrencySellRate,
            addCardBuyRate: addCardBuyRate,
            addCardSellRate: addCardSellRate,
            addRemittanceBuyRate: addRemittanceBuyRate,
            addRemittanceSellRate: addRemittanceSellRate
        };
        const obj = {
            info: infoObj,
            configList: newConfigList.length > 0 ? newConfigList : []
        };
        Common.callApi(Common.apiCredit, [sid, 'save', JSON.stringify(obj)], function (result) {
            let resp = JSON.parse(result);
            if (resp.err === "") {
                setMsgText('Saved Successfully');
                setMsgBox(true);
                if (resp.srno) {
                    setSrNo(resp.srno);
                }
                setScrMode("Q");
                setAddEditFormShow(false);
                setShowAddNewBtn(true);
                setActiveSection("info");
                resetConfigFields();
                setNewConfigList([]);
                getList();
            } else {
                setMsgText(resp.err);
                setMsgBox(true);
            }
        });
    }

    function saveConfigUpdate(editingConfigIndex) {
        const emptyToNull = (val) => (val === '' || val === undefined ? null : val);
        const obj = {
            srno: editingConfigIndex,
            groupCode: grpCode,
            accountCode: accCode,
            scheduleSrNo: srNo,
            currency: emptyToNull(currencyIsd),
            originalCurrency: originalIsd || emptyToNull(currencyIsd),
            active: emptyToNull(active),
            priority: emptyToNull(priority),
            currencyBuyFlatType: currencyBuyFlatType,
            currencyBuyMargin: emptyToNull(currencyBuyMargin),
            currencySellFlatType: currencySellFlatType,
            currencySellMargin: emptyToNull(currencySellMargin),
            cardBuyFlatType: cardBuyFlatType,
            cardBuyMargin: emptyToNull(cardBuyMargin),
            cardSellFlatType: cardSellFlatType,
            cardSellMargin: emptyToNull(cardSellMargin),
            remittanceBuyFlatType: remittanceBuyFlatType,
            remittanceBuyMargin: emptyToNull(remittanceBuyMargin),
            remittanceSellFlatType: remittanceSellFlatType,
            remittanceSellMargin: emptyToNull(remittanceSellMargin)
        };
        Common.callApi(Common.apiCredit, [sid, 'updateConfig', JSON.stringify(obj)], function (result) {
            let resp = JSON.parse(result);
            if (resp.err === "") {
                const detailObj = {
                    srno: srNo,
                    grpCode: grpCode,
                    accCode: accCode
                };
                Common.callApi(Common.apiCredit, [sid, 'detail', JSON.stringify(detailObj)], function (detailResult) {
                    let detailResp = JSON.parse(detailResult);
                    setSavedConfigList(Array.isArray(detailResp.Configuration) ? detailResp.Configuration : []); setMsgText(resp.message || 'Configuration updated successfully');
                    setEditingConfigIndex(null);
                    setMsgBox(true)
                    resetConfigOnlyFields();
                });
            } else {
                setMsgText(resp.err);
                setMsgBox(true);
            }
        });
    }

    const btnActivityLog = () => {
        setShowActivityLog(true);
        setLogObject({ trantype: "MCREDIT", trannumber: srNo, trancategory: "M" });
    }

    const handleLedgerValue = (value) => {
        setLedgerValue(value);
        const account = value.id.split('^');
        setGrpCode(account[1]);
        setAccCode(account[2]);
        setLedgerName(account[3]);
        if (scrMode === 'A') {
            const checkObj = {
                groupCode: account[1],
                accountCode: account[2],
                srno: '0'
            };
            Common.callApi(Common.apiCredit, [sid, 'checkDuplicate', JSON.stringify(checkObj)], function (result) {
                let resp = JSON.parse(result);
                if (resp.duplicate) {
                    setMsgText('Existing entry already Exist with this group and Account Code');
                    setMsgBox(true);
                    setIsDuplicate(true);
                } else {
                    setIsDuplicate(false);
                }
            });
        }
    }

    const handleChangeIsd = (value) => {
        setIsdValue(value);
        if (value) {
            const arr = value.id.split('^');
            setCurrency(arr[1] || value.id);
            setCurrencyIsd(arr[1] || value.id);
        } else {
            setCurrency('');
            setCurrencyIsd('');
        }
    }

    const isReadOnly = scrMode === "Q" || scrMode === "V";
    const configFieldsDisabled = isReadOnly && editingConfigIndex === null;

    function getConfigField(item, field) {
        const map = {
            'currencyBuyFlatType': item.mrcc_currency_buy_rate_flat_percentage || 'F',
            'currencyBuyMargin': item.mrcc_currency_buy_rate_margin ?? '',
            'currencySellFlatType': item.mrcc_currency_sell_rate_flat_percentage || 'F',
            'currencySellMargin': item.mrcc_currency_sell_rate_margin ?? '',
            'cardBuyFlatType': item.mrcc_card_buy_rate_flat_percentage || 'F',
            'cardBuyMargin': item.mrcc_card_buy_rate_margin ?? '',
            'cardSellFlatType': item.mrcc_card_sell_rate_flat_percentage || 'F',
            'cardSellMargin': item.mrcc_card_sell_rate_margin ?? '',
            'remittanceBuyFlatType': item.mrcc_remittance_buy_rate_flat_percentage || 'F',
            'remittanceBuyMargin': item.mrcc_remittance_buy_rate_margin ?? '',
            'remittanceSellFlatType': item.mrcc_remittance_sell_rate_flat_percentage || 'F',
            'remittanceSellMargin': item.mrcc_remittance_sell_rate_margin ?? ''
        };
        return map[field] ?? '';
    }

    function loadConfigIntoForm(item) {
        setCurrency(item.mrcc_isd || '');
        setCurrencyIsd(item.mrcc_isd || '');
        setIsdValue(item.mrcc_isd ? { id: item.mrcc_isd, label: item.mrcc_isd } : null);
        setOriginalIsd(item.mrcc_isd || '');
        setActive(String(item.mrcc_active ?? '1'));
        setPriority(item.mrcc_priority != null ? String(item.mrcc_priority) : '');

        setCurrencyBuyFlatType(getConfigField(item, 'currencyBuyFlatType'));
        setCurrencyBuyMargin(getConfigField(item, 'currencyBuyMargin'));
        setCurrencySellFlatType(getConfigField(item, 'currencySellFlatType'));
        setCurrencySellMargin(getConfigField(item, 'currencySellMargin'));

        setCardBuyFlatType(getConfigField(item, 'cardBuyFlatType'));
        setCardBuyMargin(getConfigField(item, 'cardBuyMargin'));
        setCardSellFlatType(getConfigField(item, 'cardSellFlatType'));
        setCardSellMargin(getConfigField(item, 'cardSellMargin'));

        setRemittanceBuyFlatType(getConfigField(item, 'remittanceBuyFlatType'));
        setRemittanceBuyMargin(getConfigField(item, 'remittanceBuyMargin'));
        setRemittanceSellFlatType(getConfigField(item, 'remittanceSellFlatType'));
        setRemittanceSellMargin(getConfigField(item, 'remittanceSellMargin'));
    }

    function editConfigEntry(idx) {
        const item = savedConfigList[idx];
        if (!item) return;
        loadConfigIntoForm(item);
        setEditingConfigIndex(idx);
        setScrMode('E');
        setActiveSection('configuration');
    }

    return (
        <>
            <LoginHeader />
            <Menu />
            <Container fluid>
                <Row>
                    <Col>
                        <h1> Master Rate Card Schedule</h1>
                    </Col>
                </Row>
                {showAddNewBtn ?
                    <Row>
                        <Col>
                            {userRight.add === "1" ?
                                <Button variant="outline-primary" className='buttonStyle' size="sm" onClick={addNew}>Add New</Button>
                                : null}
                        </Col>
                    </Row>
                    : null
                }
                <Row><Col>&nbsp;</Col></Row>
                {showAddEditForm ?
                    <Row>
                        <Col className="divContentCenter">
                            <div className="maxFormWidth">
                                <Form>
                                    <Row>
                                        <Col style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '4px' }}>
                                            {
                                                (userRight.query === "1" && (scrMode === 'E' || scrMode === 'Q' || scrMode === 'V')) ?
                                                    <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() =>
                                                        btnActivityLog()}>Activity Log</Button>
                                                    : null
                                            }
                                            {(scrMode === "A" || scrMode === "E") ?
                                                <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() => saveData()}>Save</Button>
                                                : null
                                            }
                                            {scrMode === "V" && userRight.edit === "1" ?
                                                <Button variant="outline-primary" className='buttonStyle' size="sm" onClick={() => btnEditClick()}>Edit</Button>
                                                : null
                                            }
                                            <Button variant="outline-danger" className='buttonStyle' size="sm" onClick={() => btnBackClick()}>Back</Button>
                                        </Col>
                                    </Row>

                                    <Row><Col>&nbsp;</Col></Row>
                                    <Row>
                                        <Col>
                                            <Nav variant="tabs" activeKey={activeSection}>
                                                <Nav.Item>
                                                    <Nav.Link eventKey="info" onClick={() => setActiveSection("info")}>Info</Nav.Link>
                                                </Nav.Item>
                                                <Nav.Item>
                                                    <Nav.Link eventKey="configuration" onClick={() => setActiveSection("configuration")}>Configuration</Nav.Link>
                                                </Nav.Item>
                                            </Nav>
                                        </Col>
                                    </Row>

                                    <Row><Col>&nbsp;</Col></Row>

                                    {activeSection === "info" ?
                                        <>
                                            <Row>
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label>Serial Number</Form.Label>
                                                        <Form.Control type="text" placeholder="Serial Number" value={srNo} disabled />
                                                    </Form.Group>
                                                </Col>
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label>Account<span className="text-danger">*</span></Form.Label>
                                                        <AsyncSelect
                                                            cacheOptions={false}
                                                            defaultOptions={false}
                                                            value={ledgerValue}
                                                            getOptionLabel={e => e.label + ' '}
                                                            getOptionValue={e => e.id}
                                                            loadOptions={(search) =>
                                                                Picklist.fetchLedgerAllowedInactive(search, null).then((res) => {
                                                                    console.log('loadOptions result:', res);
                                                                    return res;
                                                                })
                                                            }
                                                            onInputChange={Picklist.handleInputChange}
                                                            onChange={handleLedgerValue}
                                                            isDisabled={isReadOnly}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label>Time<span className="text-danger">*</span></Form.Label>
                                                        <Form.Control
                                                            type="time"
                                                            value={mrcsTime}
                                                            onChange={(e) => setMrcsTime(e.target.value)}
                                                            disabled={isReadOnly}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            <Row><Col>&nbsp;</Col></Row>
                                            <Row>
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label>Email To<span className="text-danger">*</span></Form.Label>
                                                        <Form.Control as="textarea" rows={2} value={emailTo} onChange={(e) => setEmailTo(e.target.value)} disabled={isReadOnly} />
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label>Email CC<span className="text-danger">*</span></Form.Label>
                                                        <Form.Control as="textarea" rows={2} value={emailCc} onChange={(e) => setEmailCc(e.target.value)} disabled={isReadOnly} />
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label>Email BCC<span className="text-danger">*</span></Form.Label>
                                                        <Form.Control as="textarea" rows={2} value={emailBcc} onChange={(e) => setEmailBcc(e.target.value)} disabled={isReadOnly} />
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label>Email Rate Card Status</Form.Label>
                                                        <Form.Select value={emailRateCardActive} onChange={(e) => setEmailRateCardActive(e.target.value)} disabled={isReadOnly}>
                                                            <option value="1">Active</option>
                                                            <option value="0">Inactive</option>
                                                        </Form.Select>
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            <Row>
                                                {/* Currency Column */}
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label>Currency Buy</Form.Label>
                                                        <Form.Select
                                                            value={addCurrencyBuyRate}
                                                            onChange={(e) => setAddCurrencyBuyRate(e.target.value)}
                                                            disabled={isReadOnly}
                                                        >
                                                            <option value="1">Active</option>
                                                            <option value="0">Inactive</option>
                                                        </Form.Select>
                                                    </Form.Group>

                                                    <Form.Group className="mt-3">
                                                        <Form.Label>Currency Sell</Form.Label>
                                                        <Form.Select
                                                            value={addCurrencySellRate}
                                                            onChange={(e) => setAddCurrencySellRate(e.target.value)}
                                                            disabled={isReadOnly}
                                                        >
                                                            <option value="1">Active</option>
                                                            <option value="0">Inactive</option>
                                                        </Form.Select>
                                                    </Form.Group>
                                                </Col>

                                                {/* Card Column */}
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label>Card Buy</Form.Label>
                                                        <Form.Select
                                                            value={addCardBuyRate}
                                                            onChange={(e) => setAddCardBuyRate(e.target.value)}
                                                            disabled={isReadOnly}
                                                        >
                                                            <option value="1">Active</option>
                                                            <option value="0">Inactive</option>
                                                        </Form.Select>
                                                    </Form.Group>

                                                    <Form.Group className="mt-3">
                                                        <Form.Label>Card Sell</Form.Label>
                                                        <Form.Select
                                                            value={addCardSellRate}
                                                            onChange={(e) => setAddCardSellRate(e.target.value)}
                                                            disabled={isReadOnly}
                                                        >
                                                            <option value="1">Active</option>
                                                            <option value="0">Inactive</option>
                                                        </Form.Select>
                                                    </Form.Group>
                                                </Col>

                                                {/* Remittance Column */}
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label>Remittance Buy</Form.Label>
                                                        <Form.Select
                                                            value={addRemittanceBuyRate}
                                                            onChange={(e) => setAddRemittanceBuyRate(e.target.value)}
                                                            disabled={isReadOnly}
                                                        >
                                                            <option value="1">Active</option>
                                                            <option value="0">Inactive</option>
                                                        </Form.Select>
                                                    </Form.Group>

                                                    <Form.Group className="mt-3">
                                                        <Form.Label>Remittance Sell</Form.Label>
                                                        <Form.Select
                                                            value={addRemittanceSellRate}
                                                            onChange={(e) => setAddRemittanceSellRate(e.target.value)}
                                                            disabled={isReadOnly}
                                                        >
                                                            <option value="1">Active</option>
                                                            <option value="0">Inactive</option>
                                                        </Form.Select>
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                        </>
                                        : null}
                                    {activeSection === "configuration" ?
                                        <>
                                            <Row>
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label>Account<span className="text-danger">*</span></Form.Label>
                                                        <AsyncSelect
                                                            cacheOptions={false}
                                                            defaultOptions={false}
                                                            value={ledgerValue}
                                                            getOptionLabel={e => e.label + ' '}
                                                            getOptionValue={e => e.id}
                                                            loadOptions={(search) => Picklist.fetchLedgerAllowedInactive(search, null)}
                                                            onInputChange={Picklist.handleInputChange}
                                                            onChange={handleLedgerValue}
                                                            isDisabled={true}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label>Priority</Form.Label>
                                                        <Form.Control
                                                            type="number"
                                                            value={priority}
                                                            onChange={(e) => setPriority(e.target.value)}
                                                            disabled={configFieldsDisabled}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label>Currency (ISD)<span className="text-danger">*</span></Form.Label>
                                                        <AsyncSelect
                                                            cacheOptions={false}
                                                            defaultOptions={false}
                                                            value={isdValue}
                                                            getOptionLabel={e => e.label + ' '}
                                                            getOptionValue={e => e.id}
                                                            loadOptions={(search) => Picklist.fetchCurrencyAllowedPicklist(search, null)}
                                                            onInputChange={Picklist.handleInputChange}
                                                            onChange={handleChangeIsd}
                                                            isDisabled={configFieldsDisabled}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label>Active</Form.Label>
                                                        <Form.Select value={active} onChange={(e) => setActive(e.target.value)} disabled={configFieldsDisabled}>
                                                            <option value="1">Active</option>
                                                            <option value="0">Inactive</option>
                                                        </Form.Select>
                                                    </Form.Group>
                                                </Col>
                                            </Row>

                                            <Row><Col>&nbsp;</Col></Row>
                                            <hr></hr>
                                            <h6>Currency</h6>
                                            <Row>
                                                <Col>
                                                    <Form.Group className="mt-1">
                                                        <Form.Label>Buy Rate Flat %</Form.Label>
                                                        <Form.Select
                                                            size="sm"
                                                            value={currencyBuyFlatType}
                                                            onChange={(e) => setCurrencyBuyFlatType(e.target.value)}
                                                            disabled={configFieldsDisabled}
                                                        >
                                                            <option value="F">Flat</option>
                                                            <option value="P">Percent</option>
                                                        </Form.Select>
                                                    </Form.Group>
                                                </Col>
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label>Buy Rate Margin</Form.Label>
                                                        <Form.Control
                                                            type="number"
                                                            value={currencyBuyMargin}
                                                            onChange={(e) => setCurrencyBuyMargin(e.target.value)}
                                                            disabled={configFieldsDisabled}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col>
                                                    <Form.Group className="mt-1">
                                                        <Form.Label>Sell Rate Flat %</Form.Label>
                                                        <Form.Select
                                                            size="sm"
                                                            value={currencySellFlatType}
                                                            onChange={(e) => setCurrencySellFlatType(e.target.value)}
                                                            disabled={configFieldsDisabled}
                                                        >
                                                            <option value="F">Flat</option>
                                                            <option value="P">Percent</option>
                                                        </Form.Select>
                                                    </Form.Group>
                                                </Col>
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label>Sell Rate Margin</Form.Label>
                                                        <Form.Control
                                                            type="number"
                                                            value={currencySellMargin}
                                                            onChange={(e) => setCurrencySellMargin(e.target.value)}
                                                            disabled={configFieldsDisabled}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            <Row><Col>&nbsp;</Col></Row>
                                            <hr></hr>
                                            <h6>Card</h6>
                                            <Row>
                                                <Col>
                                                    <Form.Group className="mt-1">
                                                        <Form.Label>Buy Rate Flat %</Form.Label>
                                                        <Form.Select
                                                            size="sm"
                                                            value={cardBuyFlatType}
                                                            onChange={(e) => setCardBuyFlatType(e.target.value)}
                                                            disabled={configFieldsDisabled}
                                                        >
                                                            <option value="F">Flat</option>
                                                            <option value="P">Percent</option>
                                                        </Form.Select>
                                                    </Form.Group>
                                                </Col>
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label>Buy Rate Margin</Form.Label>
                                                        <Form.Control
                                                            type="number"
                                                            value={cardBuyMargin}
                                                            onChange={(e) => setCardBuyMargin(e.target.value)}
                                                            disabled={configFieldsDisabled}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col>
                                                    <Form.Group className="mt-1">
                                                        <Form.Label>Sell Rate Flat %</Form.Label>
                                                        <Form.Select
                                                            size="sm"
                                                            value={cardSellFlatType}
                                                            onChange={(e) => setCardSellFlatType(e.target.value)}
                                                            disabled={configFieldsDisabled}
                                                        >
                                                            <option value="F">Flat</option>
                                                            <option value="P">Percent</option>
                                                        </Form.Select>
                                                    </Form.Group>
                                                </Col>
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label>Sell Rate Margin</Form.Label>
                                                        <Form.Control
                                                            type="number"
                                                            value={cardSellMargin}
                                                            onChange={(e) => setCardSellMargin(e.target.value)}
                                                            disabled={configFieldsDisabled}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            <Row><Col>&nbsp;</Col></Row>
                                            <hr></hr>
                                            <h6>Remittance</h6>
                                            <Row>
                                                <Col>
                                                    <Form.Group className="mt-1">
                                                        <Form.Label>Buy Rate Flat %</Form.Label>
                                                        <Form.Select
                                                            size="sm"
                                                            value={remittanceBuyFlatType}
                                                            onChange={(e) => setRemittanceBuyFlatType(e.target.value)}
                                                            disabled={configFieldsDisabled}
                                                        >
                                                            <option value="F">Flat</option>
                                                            <option value="P">Percent</option>
                                                        </Form.Select>
                                                    </Form.Group>
                                                </Col>
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label>Buy Rate Margin</Form.Label>
                                                        <Form.Control
                                                            type="number"
                                                            value={remittanceBuyMargin}
                                                            onChange={(e) => setRemittanceBuyMargin(e.target.value)}
                                                            disabled={configFieldsDisabled}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col>
                                                    <Form.Group className="mt-1">
                                                        <Form.Label>Sell Rate Flat %</Form.Label>
                                                        <Form.Select
                                                            size="sm"
                                                            value={remittanceSellFlatType}
                                                            onChange={(e) => setRemittanceSellFlatType(e.target.value)}
                                                            disabled={configFieldsDisabled}
                                                        >
                                                            <option value="F">Flat</option>
                                                            <option value="P">Percent</option>
                                                        </Form.Select>
                                                    </Form.Group>
                                                </Col>
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label>Sell Rate Margin</Form.Label>
                                                        <Form.Control
                                                            type="number"
                                                            value={remittanceSellMargin}
                                                            onChange={(e) => setRemittanceSellMargin(e.target.value)}
                                                            disabled={configFieldsDisabled}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            <Row><Col>&nbsp;</Col></Row>

                                            {!isReadOnly ?
                                                <Row>
                                                    <Col>
                                                        <Button variant="outline-success" className='buttonStyle' size="sm" onClick={addConfigEntry}>Add</Button>
                                                    </Col>
                                                </Row>
                                                : null}

                                            <Row><Col>&nbsp;</Col></Row>
                                            <Row>
                                                <Col>
                                                    <Table responsive striped bordered hover size="sm">
                                                        <thead>
                                                            <tr>
                                                                <th>Actions</th>
                                                                <th>Sr No</th>
                                                                <th>Account</th>
                                                                <th>ISD</th>
                                                                <th>Active</th>
                                                                <th>Priority</th>
                                                                <th>Curr Buy Flat%</th>
                                                                <th>Curr Buy Margin</th>
                                                                <th>Curr Sell Flat%</th>
                                                                <th>Curr Sell Margin</th>
                                                                <th>Card Buy Flat%</th>
                                                                <th>Card Buy Margin</th>
                                                                <th>Card Sell Flat%</th>
                                                                <th>Card Sell Margin</th>
                                                                <th>Rem Buy Flat%</th>
                                                                <th>Rem Buy Margin</th>
                                                                <th>Rem Sell Flat%</th>
                                                                <th>Rem Sell Margin</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {savedConfigList.length === 0 && newConfigList.length === 0 ?
                                                                <tr>
                                                                    <td colSpan={18} className="textCenter">No entries added</td>
                                                                </tr>
                                                                : <>
                                                                    {savedConfigList.map((item, idx) =>
                                                                        <tr key={`saved-${idx}`}>
                                                                            <td className="textCenter">
                                                                                <span className="handCursor" onClick={() => editConfigEntry(idx)}>
                                                                                    <FontAwesomeIcon className="colorThemeBlue" icon={faEdit} />
                                                                                </span>
                                                                            </td>
                                                                            <td>{idx + 1}</td>
                                                                            <td>{ledgerValue.label}</td>
                                                                            <td>{item.mrcc_isd || ''}</td>
                                                                            <td>{(item.mrcc_active === '1' || item.mrcc_active === 1) ? 'Active' : 'Inactive'}</td>
                                                                            <td>{item.mrcc_priority || ''}</td>
                                                                            <td>{item.mrcc_currency_buy_rate_flat_percentage || ''}</td>
                                                                            <td>{item.mrcc_currency_buy_rate_margin || ''}</td>
                                                                            <td>{item.mrcc_currency_sell_rate_flat_percentage || ''}</td>
                                                                            <td>{item.mrcc_currency_sell_rate_margin || ''}</td>
                                                                            <td>{item.mrcc_card_buy_rate_flat_percentage || ''}</td>
                                                                            <td>{item.mrcc_card_buy_rate_margin || ''}</td>
                                                                            <td>{item.mrcc_card_sell_rate_flat_percentage || ''}</td>
                                                                            <td>{item.mrcc_card_sell_rate_margin || ''}</td>
                                                                            <td>{item.mrcc_remittance_buy_rate_flat_percentage || ''}</td>
                                                                            <td>{item.mrcc_remittance_buy_rate_margin || ''}</td>
                                                                            <td>{item.mrcc_remittance_sell_rate_flat_percentage || ''}</td>
                                                                            <td>{item.mrcc_remittance_sell_rate_margin || ''}</td>
                                                                        </tr>
                                                                    )}
                                                                    {newConfigList.map((item, idx) =>
                                                                        <tr key={`new-${idx}`}>
                                                                            <td className="textCenter">
                                                                                {!isReadOnly ?
                                                                                    <FontAwesomeIcon className="colorThemeRed handCursor" onClick={() => removeConfigEntry(idx)} icon={faTrashAlt} />
                                                                                    : null}
                                                                            </td>
                                                                            <td>{savedConfigList.length + idx + 1}</td>
                                                                            <td>{ledgerValue?.label || ''}</td>
                                                                            <td>{item.currency || ''}</td>
                                                                            <td>{item.active === '1' ? 'Active' : 'Inactive'}</td>
                                                                            <td>{item.priority || ''}</td>
                                                                            <td>{item.currencyBuyFlatType || ''}</td>
                                                                            <td>{item.currencyBuyMargin || ''}</td>
                                                                            <td>{item.currencySellFlatType || ''}</td>
                                                                            <td>{item.currencySellMargin || ''}</td>
                                                                            <td>{item.cardBuyFlatType || ''}</td>
                                                                            <td>{item.cardBuyMargin || ''}</td>
                                                                            <td>{item.cardSellFlatType || ''}</td>
                                                                            <td>{item.cardSellMargin || ''}</td>
                                                                            <td>{item.remittanceBuyFlatType || ''}</td>
                                                                            <td>{item.remittanceBuyMargin || ''}</td>
                                                                            <td>{item.remittanceSellFlatType || ''}</td>
                                                                            <td>{item.remittanceSellMargin || ''}</td>
                                                                        </tr>
                                                                    )}
                                                                </>
                                                            }
                                                        </tbody>
                                                    </Table>
                                                </Col>
                                            </Row>
                                            <Row><Col style={{ marginBottom: '2rem' }}>&nbsp;</Col></Row>
                                        </>
                                        : null}
                                    <Row><Col>&nbsp;</Col></Row>
                                </Form>
                            </div>
                        </Col>
                    </Row>
                    : null}

                {scrMode === "Q" ?
                    <Row>
                        <Col>
                            <Table responsive striped bordered hover>
                                <thead>
                                    <tr>
                                        {userRight.query === "1" ? <th></th> : null}
                                        <th className="textRight">Sr No</th>
                                        <th>Group</th>
                                        <th>Account</th>
                                        <th>Ledger Name</th>
                                        <th>Time</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {creditScheduleData.length > 0 ? creditScheduleData.map((res) =>
                                        <tr key={res.mrcs_srno}>
                                            {userRight.query === "1" ?
                                                <td className="textCenter">
                                                    <span className="handCursor" onClick={() => fillViewForm(res.mrcs_srno, res.mrcs_group_code, res.mrcs_account_code)}>
                                                        <div className="colorThemeBlue"><FontAwesomeIcon icon={faEye} /></div>
                                                    </span>
                                                </td>
                                                : null
                                            }
                                            <td className="textRight">{res.mrcs_srno}</td>
                                            <td>{res.mrcs_group_code}</td>
                                            <td>{res.mrcs_account_code}</td>
                                            <td>{res.mvli_ledger_name}</td>
                                            <td>{res.mrcs_time}</td>
                                        </tr>
                                    ) : (
                                        <tr>
                                            <td colSpan="4" className="textCenter">Data not found</td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                    : null
                }
            </Container>
            <ActivityLog logObject={logObject} show={showActivityLog} onHide={() => setShowActivityLog(false)} />
            <div>
                <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                    {msgText}
                </Dialog>
            </div>
        </>
    );
}

export default Master_Credit_Schedule;
